import React from "react";
import { useUserContext } from "context/UserContext";
import { normalizeRoleLevel } from "utils/roleUtils";
import WarehousesRealtimeBK from "layouts/BK/warehousesRealtime";

function WarehousesRealtime() {
  const { roleLevel } = useUserContext() || {};
  if (normalizeRoleLevel(roleLevel)) {
    return <WarehousesRealtimeBK />;
  }
  return <WarehousesRealtimeBK />;
}

export default WarehousesRealtime;
